module.exports = __webpack_public_path__ + "img/novelty-scanner-qr.0b9c674e.png";